import React from 'react';
import './MountainBackground.css';

const MountainBackground = () => {
  return (
    <div className="mountain-background">
      {/* Mountain landscape background */}
    </div>
  );
};

export default MountainBackground;



